import React from "react";
import { useSupportHeaderSlide } from "@/v2-components/pages/support/hooks/use-support-header-slide";
import { SupportAccordionSlide } from "@/v2-components/pages/support/components/shared/support-accordion-slide";
import { SupportHeaderSlideFixContents } from "@/v2-components/pages/support/shared/support-header-slide-fix-contents";
import { DownloadsEnum } from "@/v2-components/pages/support/types/support-downloads-type";
import { useRouter } from "next/router";
import { cn } from "@/libs/utils";

export const SupportDownloadsSlideSection = () => {
  const { isSlideOpen, slideStandardRef, handleSlideToggle, handleSlideClose } =
    useSupportHeaderSlide();

  return (
    <SupportAccordionSlide
      isOpen={isSlideOpen}
      setIsOpen={handleSlideToggle}
      className={"smd:flex md:hidden"}
      fixedContent={
        <SupportHeaderSlideFixContents
          slideStandardRef={slideStandardRef}
          slideOpen={isSlideOpen}
          setSlideOpen={handleSlideToggle}
          title={"Downloads"}
          className={"smd:flex md:hidden"}
        />
      }
      slideContent={
        <SupportSlideDownloadsContents slideClose={handleSlideClose} />
      }
    />
  );
};

const SupportSlideDownloadsContents = ({
  slideClose,
}: {
  slideClose: () => void;
}) => {
  const router = useRouter();
  const { type } = router.query;

  const handleOnClickSideBar = (id: DownloadsEnum) => {
    router.push(`/support/downloads?type=${id}`);
    slideClose();
  };

  const isPrevPage = (id: DownloadsEnum) => {
    return type === id;
  };

  const options = [
    { id: DownloadsEnum.Manual, label: "Manual" },
    { id: DownloadsEnum.BhapticsPlayer, label: "bHaptics Player" },
  ];

  return (
    <div className="flex flex-col">
      {options.map((option) => (
        <div
          key={option.id}
          className={cn(
            "flex cursor-pointer items-center justify-between py-4 text-coolgray-100",
            {
              "font-600": isPrevPage(option.id),
            },
          )}
          onClick={() => handleOnClickSideBar(option.id)}
        >
          <div className="min-w-0 flex-grow">
            <span className={"flex gap-2"}>
              <div className="max-w-xs truncate">{option.label}</div>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
